import { default as getOptions } from "@pb/utils/common/getOptions";
import { default as getLabelFromStorage } from "@pb/utils/labels/getLabelFromStorage";
import { default as getCurrentBreakpoint } from "@pb/utils/getCurrentBreakpoint";
import { PraIds } from '../../constants';
import mapE3Product from '../mapE3Product';
import mapE4Product from '../mapE4Product';
import mapHaalProduct from '../mapHaalProduct';
const mapRecommendationsToCarousel = ({ articles, disableFavorites = true, eSalesAsSource = false, praConfiguration, priorPriceLabel, isE4Enabled = false, }) => {
    let formattedPriorLabel = priorPriceLabel || getLabelFromStorage('commerce_product_price_priorPrice');
    if (formattedPriorLabel === null || formattedPriorLabel === void 0 ? void 0 : formattedPriorLabel.includes('{0}')) {
        formattedPriorLabel = formattedPriorLabel.replace('{0}', '').trim();
    }
    const dataLabels = Object.assign({ newArrival: getLabelFromStorage('product.newArrivalText') === 'product.newArrivalText'
            ? getLabelFromStorage('commerce_product_newArrival')
            : getLabelFromStorage('product.newArrivalText'), clubMemberPrice: getOptions('product.clubMemberPriceLabel'), priorPriceLabel: formattedPriorLabel }, (praConfiguration.ID === PraIds.PRA2 && {
        outOfStockLabel: getLabelFromStorage('commerce_producttile_details_outOfStockText'),
    }));
    const { RESOLVER, LAZYLOAD_IMAGES, ID } = praConfiguration;
    const numberOfItemsPerSlide = praConfiguration.NUM_OF_ITEMS_PER_SLIDE[getCurrentBreakpoint()];
    return articles.map((article, index) => {
        const shouldUseLazy = !(index < numberOfItemsPerSlide);
        return Object.assign(Object.assign(Object.assign({}, (LAZYLOAD_IMAGES &&
            ID !== PraIds.SWG && {
            shouldLazyLoad: shouldUseLazy,
            shouldDelayLazyLoad: shouldUseLazy,
            lazyLoadDelayMs: 500,
        })), (process.env.IS_PRA_LP_RESOLVER_ENABLED === 'enabled' &&
            RESOLVER && {
            resolverSettings: {
                width: RESOLVER.WIDTH,
                height: RESOLVER.HEIGHT,
            },
            shouldUseResolver: true,
        })), (eSalesAsSource
            ? isE4Enabled
                ? mapE4Product(article)
                : mapE3Product(article, disableFavorites, dataLabels)
            : mapHaalProduct(article, disableFavorites, dataLabels)));
    });
};
export default mapRecommendationsToCarousel;
//# sourceMappingURL=mapRecommendationsToCarousel.js.map